module.exports = __webpack_public_path__ + "img/design@2x.ebaa591.webp";